// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ImZELqAOSc8ZcsM7ug0k{align-items:center;gap:8px;padding:10px 0;display:flex}.M199nGVD5OYy_IjrGgA3{flex-direction:column;gap:4px;min-width:0;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"name": `ImZELqAOSc8ZcsM7ug0k`,
	"nameInfo": `M199nGVD5OYy_IjrGgA3`
};
export default ___CSS_LOADER_EXPORT___;
